<div [ngStyle]="getStyles()"></div>
